export const amendSelectionStatuses = {
  rejected: 'rejected',
  amended: 'amended',
}
